/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './op-procedure-order-item.reducer';

export const OpProcedureOrderItem = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const opProcedureOrderItemList = useAppSelector(state => state.opProcedureOrderItem.entities);
  const loading = useAppSelector(state => state.opProcedureOrderItem.loading);
  const totalItems = useAppSelector(state => state.opProcedureOrderItem.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="op-procedure-order-item-heading" data-cy="OpProcedureOrderItemHeading">
        <Translate contentKey="tinyMedicRestApp.opProcedureOrderItem.home.title">Op Procedure Order Items</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.opProcedureOrderItem.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/op-procedure-order-item/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.opProcedureOrderItem.home.createLabel">Create new Op Procedure Order Item</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.opProcedureOrderItem.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {opProcedureOrderItemList && opProcedureOrderItemList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.opProcedureOrderItem.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.opProcedureOrderItem.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.opProcedureOrderItem.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.opProcedureOrderItem.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.opProcedureOrderItem.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.opProcedureOrderItem.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('totalCost')}>
                  <Translate contentKey="tinyMedicRestApp.opProcedureOrderItem.totalCost">Total Cost</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('totalCost')} />
                </th>
                <th className="hand" onClick={sort('notes')}>
                  <Translate contentKey="tinyMedicRestApp.opProcedureOrderItem.notes">Notes</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('notes')} />
                </th>
                <th className="hand" onClick={sort('orderStatus')}>
                  <Translate contentKey="tinyMedicRestApp.opProcedureOrderItem.orderStatus">Order Status</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('orderStatus')} />
                </th>
                <th className="hand" onClick={sort('procedureStatus')}>
                  <Translate contentKey="tinyMedicRestApp.opProcedureOrderItem.procedureStatus">Procedure Status</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('procedureStatus')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.opProcedureOrderItem.order">Order</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.opProcedureOrderItem.procedure">Procedure</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.opProcedureOrderItem.exam">Exam</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.opProcedureOrderItem.tooth">Tooth</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.opProcedureOrderItem.surface">Surface</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {opProcedureOrderItemList.map((opProcedureOrderItem, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/op-procedure-order-item/${opProcedureOrderItem.id}`} color="link" size="sm">
                      {opProcedureOrderItem.id}
                    </Button>
                  </td>
                  <td>{opProcedureOrderItem.active ? 'true' : 'false'}</td>
                  <td>{opProcedureOrderItem.microSec}</td>
                  <td>{opProcedureOrderItem.timestampEntry}</td>
                  <td>{opProcedureOrderItem.lastUpdated}</td>
                  <td>{opProcedureOrderItem.cursor}</td>
                  <td>{opProcedureOrderItem.totalCost}</td>
                  <td>{opProcedureOrderItem.notes}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.OrderStatus.${opProcedureOrderItem.orderStatus}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.ProcedureStatus.${opProcedureOrderItem.procedureStatus}`} />
                  </td>
                  <td>
                    {opProcedureOrderItem.order ? (
                      <Link to={`/op-procedure-order/${opProcedureOrderItem.order.id}`}>{opProcedureOrderItem.order.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {opProcedureOrderItem.procedure ? (
                      <Link to={`/hospital-procedure/${opProcedureOrderItem.procedure.id}`}>{opProcedureOrderItem.procedure.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {opProcedureOrderItem.exam ? (
                      <Link to={`/dental-exam-and-treatment/${opProcedureOrderItem.exam.id}`}>{opProcedureOrderItem.exam.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {opProcedureOrderItem.tooth ? (
                      <Link to={`/dental-mouth-item/${opProcedureOrderItem.tooth.id}`}>{opProcedureOrderItem.tooth.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {opProcedureOrderItem.surface ? (
                      <Link to={`/dental-surface/${opProcedureOrderItem.surface.id}`}>{opProcedureOrderItem.surface.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/op-procedure-order-item/${opProcedureOrderItem.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/op-procedure-order-item/${opProcedureOrderItem.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/op-procedure-order-item/${opProcedureOrderItem.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.opProcedureOrderItem.home.notFound">No Op Procedure Order Items found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={opProcedureOrderItemList && opProcedureOrderItemList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default OpProcedureOrderItem;
